module.exports = __webpack_public_path__ + "img/Background-Mugs-2366x901.4f2bad19.jpeg";